import { computed } from 'vue';
import { defineStore } from '@dh-io-owpi/shared/src/stores/store';
import { useVehicleStore } from './vehicle';

interface ThemeState {
  wb: 'light' | 'dark';
  dark: boolean;
}

export const useThemeStore = defineStore('spa-theme', () => {
  const vehicleStore = useVehicleStore();

  const theme = computed<ThemeState>(() => {
    const dark = vehicleStore.brandId === 'MERCEDES_AMG';
    return { dark, wb: dark ? 'dark' : 'light' };
  });

  return { theme };
});

/**
 * Returns the current theme, based on the selected style.
 */
export const useTheme = () => useThemeStore().theme;
